














































































import Vue from 'vue';
import Component from 'vue-class-component';
import Heading from '../components/Heading.vue';
import Errors from '../components/Errors.vue';
import Editor from '../components/Editor.vue';
import FileUpload from '../components/FileUpload.vue';
import CompanySelect from '../components/CompanySelect.vue';
import TicketTypeSelect from '../components/TicketTypeSelect.vue';
import { TicketInformation } from '../store/ticketsStore.d';
import adBlockerDetector from '../helpers/adBlockerDetector';

const ticketInformation: TicketInformation = {
  subject: '',
  type: '',
  company: '',
  message: '',
  userAgent: '',
  screenSize: '',
  adBlockerEnabled: false,
  files: [],
};

const CreateProps = Vue.extend({
  //
});

@Component({
  name: 'Create',

  components: {
    Heading,
    Errors,
    Editor,
    FileUpload,
    CompanySelect,
    TicketTypeSelect,
  },
})
export default class Create extends CreateProps {
  $refs!: {
    fileUpload: FileUpload;
  }

  formInput = ticketInformation;

  errors: Array<string> = [];

  get createTicketLoadingState() {
    return this.$store.getters.createTicketLoadingState;
  }

  get user() {
    return this.$store.getters.user;
  }

  get companies() {
    return this.user
      ? this.user.companies
      : null;
  }

  get ticketTypes() {
    return this.$store.getters.ticketTypes;
  }

  mounted() {
    this.$store.dispatch('fetchTicketTypes');

    adBlockerDetector().then((result: boolean) => {
      this.formInput.adBlockerEnabled = result;
    });
  }

  validate() {
    const errors: Array<string> = [];

    if (!this.formInput.subject) {
      errors.push('Voer een onderwerp in');
    }

    if (!this.formInput.type) {
      errors.push('Selecteer een soort opdracht');
    }

    if (!this.formInput.message) {
      errors.push('Voer een beschrijving in');
    }

    if (this.$refs.fileUpload) {
      if (this.$refs.fileUpload.getFilesInProgress().length > 0) {
        errors.push('Er zijn nog bestanden aan het uploaden');
      }
    }

    return errors;
  }

  create() {
    this.errors = this.validate();

    if (this.errors.length > 0) {
      return;
    }

    this.formInput.userAgent = navigator.userAgent;
    this.formInput.screenSize = `${window.screen.width}x${window.screen.height}`;

    this.$store
      .dispatch('createTicket', this.formInput)
      .then(({ data }) => {
        this.$router.push({ name: 'Ticket', params: { id: data.id } });
      })
      .catch((err: Error) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  }
}
